<div id="alert" [class]="eAlertType[type]">
  <div class="content">
    <div class="alert-icon">
      <atm-icon [iconKey]="eIconKey.alert" [size]="eSizesIcon.Size36" [statusIcon]="alertIcons[type]"></atm-icon>
    </div>
    <div class="main-text">
      <atm-text-ui [fontColor]="textColors[type]" [fontWeight]="eFontWeight.bold">{{ text }}</atm-text-ui>
    </div>
    <div class="description">
      <atm-text-ui [fontColor]="textColors[type]">{{ description }}</atm-text-ui>
    </div>
    <div class="button" *ngIf="isShowPrimaryButton">
      <mol-button
        id="primary-button"
        [size]="eButtonSizes.m"
        [type]="primaryButtonType"
        (submitEvent)="onPrimaryButtonClick()"
        >{{ primaryButtonText }}</mol-button
      >
    </div>
    <div class="button" *ngIf="isShowSecondaryButton">
      <mol-button
        id="secondary-button"
        [size]="eButtonSizes.m"
        [type]="secondaryButtonType"
        (submitEvent)="onSecondaryButtonClick()"
        >{{ secondaryButtonText }}</mol-button
      >
    </div>
    <div class="button" *ngIf="isShowLinkButton">
      <mol-button-link
        id="link-button"
        [size]="eButtonSizes.m"
        [fontColor]="eFontColor.link"
        (submitEvent)="onLinkButtonClick()"
        >{{ linkButtonText }}</mol-button-link
      >
    </div>
  </div>
  <atm-icon id="close" *ngIf="isShowClose" [iconKey]="eIconKey.close" (click)="onClose()"></atm-icon>
</div>
